import axios from "axios"
import TRTC from "trtc-js-sdk";
import Bus from "./bus"

// import * as LibGenerateTestUserSig from './lib-generate-test-usersig.min.js'
class o2vrClient {
    constructor() {
        //凭证
        this.config = {
            mode: "rtc",
            sdkAppId: 1400610125,
            userId: '',
            usersig: ''
        }
        //客户端
        this.client = ""
        this.list = []
    }

    //登录client
    async login(userid, roomId) {
       
        //获取签证
        // const SDKAPPID = 1400601861;
        // const EXPIRETIME = 604800;
        // const SECRETKEY = 'fe1ea13d889fc1a987cc2164bca5818e172dd777659827521606da9418a8c472';
        // const generator = new LibGenerateTestUserSig(SDKAPPID, SECRETKEY, EXPIRETIME)
        // const userSig = generator.genTestUserSig(userID)
        // this.config.userId = userid
        // this.config.userSig = generator.genTestUserSig(userid)
        Bus.$on("mute", (target) => {
            console.log("静音", 123123)
            if (target) {
                localStream.unmuteAudio();
            } else {
                localStream.muteAudio();
            }
        })

        Bus.$on("vmute", (target) => {
            console.log("静音", target)
            if (target[0]) {
                localStream.unmuteVideo();
            } else {
                localStream.muteVideo();
            }
        })
        await this.get(userid).then(res => {
            this.config.userId = userid
            this.config.userSig = res
        })
        //建立客户端
        this.client = await TRTC.createClient(this.config);
        let remoteStreamList = [];
        //订阅远方流
        await this.client.on("stream-added", (event) => {
            const remoteStream = event.stream;
            console.log("远端流增加: " + remoteStream.getId());
            this.client.subscribe(remoteStream);

        });

        await this.client.on('stream-removed', ({ stream: remoteStream }) => {
            remoteStreamList = remoteStreamList.filter(stream => {
                return stream.getId() !== remoteStream.getId();
            });

            this.list = this.list.filter(stream => {
                return stream.id !== remoteStream.getId();
            });

            Bus.$emit("list", this.list)

        })

        // 播放远端流
        await this.client.on("stream-subscribed", (event) => {
            const remoteStream = event.stream;
            remoteStreamList.push(remoteStream);
            console.log(remoteStream)
            this.list.push({
                id: remoteStream.getId(),
                name: remoteStream.getUserId(),
                volume: 0
            })
            Bus.$emit("list", this.list)
            console.log("远端流订阅成功：" + remoteStream.getId());
            var name = remoteStream.getUserId()
            // let arr = name.split("-");
            // if(arr.length > 1){
            //     name = arr[1];

            var div = document.createElement('div')
            div.id = name
            div.style.width = 0
            
            document.body.appendChild(div)
            console.log(div)
            remoteStream.play(name);
            setTimeout(() => {
                Bus.$emit("stream", ['remote_stream', name])
            }, 500);

            //}
        });

        // 开始获取流音量
        let getAudioLevelTimer = -1;
        var that = this
        function startGetAudioLevel() {
            getAudioLevelTimer = setAnimationFrame(() => {

                if (localStream) {
                    const level = localStream.getAudioLevel();

                    if (level >= 0.1) {
                        // console.warn(`user ${localStream.getUserId()} is speaking, volume: ${level}`);
                        // 在页面中渲染用户音量大小
                    }
                }
                remoteStreamList.forEach(stream => {
                    const level = stream.getAudioLevel();

                    that.list.find(function (value) {
                        if (value.id == stream.getId()) {
                            value.volume = level
                        };
                    })
                    Bus.$emit("list", that.list)
                    // console.warn(`user ${stream.getUserId()} is speaking, volume: ${level}`);
                    // 在页面中渲染用户音量大小

                });
            });
        }
        // 停止获取流音量
        function stopGetAudioLevel() {
            if (getAudioLevelTimer !== -1) {
                clearAnimationFrame(getAudioLevelTimer);
                getAudioLevelTimer = -1;
            }
        }

        // 设置AnimationFrame
        function setAnimationFrame(render) {
            // 计时器
            let timer = {};
            function animeLoop() {
                render();
                timer.id = requestAnimationFrame(animeLoop);
            }
            animeLoop();
            return timer;
        }
        // 清除AnimationFrame
        function clearAnimationFrame(timer) {
            cancelAnimationFrame(timer.id);
        }
        //进入房间
        await this.client
            .join({ roomId })
            .catch((error) => {
                console.error("进房失败 " + error);
            })
            .then(() => {
                console.log("进房成功");
            });
        //await this.shareScreen(roomId);
        var localStream
        await TRTC.getCameras().then(res => {

            if (res.length != 0) {
                console.log("拥有摄像头", res[0])
                localStream = TRTC.createStream({
                    userId: this.config.userId,
                    audio: true,
                    video: true,
                });


            } else {
                console.log("没有摄像头开启语音")
                localStream = TRTC.createStream({
                    userId: this.config.userId,
                    audio: true,
                    video: false,
                });

                // localStream.muteAudio();
            }
        })
        //创建流


        //初始化本地音视频流。

        await localStream
            .initialize()
            .catch((error) => {
                console.log("初始化本地流失败 " + error)
                return
            })
            .then(() => {
                console.log("初始化本地流成功");
                localStream.play('local_stream');
                setTimeout(() => {
                    Bus.$emit("stream", ['local_stream', ''])
                }, 500);
                localStream.muteAudio();
                localStream.muteVideo()
            });
        //发布本地流
        await this.client
            .publish(localStream)
            .catch((error) => {
                console.error("本地流发布失败 " + error);
            })
            .then(() => {
                console.log("本地流发布成功");
                startGetAudioLevel()
            });


    }

    async loginOut() {
        this.client
            .leave()
            .then(() => {
                // 退房成功，可再次调用client.join重新进房开启新的通话。
                console.log("退房成功")
                this.list = []
            })
            .catch(error => {
                console.error('退房失败 ' + error);
                // 错误不可恢复，需要刷新页面。
            });
    }

    async shareScreen(roomId) {
        if (!this.shareCfg) {
            this.shareCfg = {};
            this.shareCfg.mode = "rtc";
            this.shareCfg.sdkAppId = this.config.sdkAppId;
            this.shareCfg.userId = "share-" + this.config.userId;
            this.shareCfg.userSig = this.config.userSig;
            this.shareCfg.autoSubscribe = false;
        }
        await this.get(this.shareCfg.userId).then(res => {
            this.shareCfg.userSig = res;
        })
        this.shareClient = await TRTC.createClient(this.shareCfg);
        let shareStream = await TRTC.createStream(
            { userId: this.shareCfg.userId, audio: false, screen: true });
        shareStream.setScreenProfile("1080p");
        //.then(()=>{
        //     shareStream.play("local_stream");
        //     setTimeout(() => {
        //         Bus.$emit("stream", ['local_stream', ''])
        //     }, 500);
        //});
        await this.shareClient.join({ roomId });
        shareStream.initialize().then(() => {
            this.shareClient.publish(shareStream)
                .catch((error) => {
                    console.error("桌面分享失败 " + error);
                })
                .then(() => {
                    console.log("桌面分享成功");
                    //startGetAudioLevel()
                });;
        });
    }
    test() {
        this.client.leave()
            .then(() => {
                this.client.join({ roomId: 1000 }).then(() => {
                    //this.client.roomId
                    console.log("重新加入1000频道", this.client);
                }
                )
            }
            );
    }

    //获取签证
    get(userid) {
        return new Promise((resolve, reject) => {
            axios
                .get('https://o2vr.net/usersig/usersig.php', {
                    params: {
                        userid
                    },
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err.data);
                });
        })

    }
}

export { o2vrClient };